import axiosClient from "@/api/common/axiosClient.ts";

export const changePassword = ({
  currentPassword,
  newPassword,
}: {
  currentPassword: string;
  newPassword: string;
}) => {
  return axiosClient.put("users/password_update/", {
    current_password: currentPassword,
    new_password: newPassword,
    confirm_password: newPassword,
  });
};

export type ChangePasswordErrorType = string[];
